var map = {
	"./CIW Site Development Associate.pdf": 947,
	"./CompTIA Project+ certificate.pdf": 974,
	"./ITIL Foundations e-Cert.pdf": 488,
	"./Images/Portfolio/apidemo.png": 719,
	"./Images/Portfolio/gotmoney.jpg": 130,
	"./Images/Portfolio/resume-website.jpg": 893,
	"./Images/Portfolio/texttospeech.png": 620,
	"./Images/loader.gif": 473,
	"./Images/logo-orginal.png": 721,
	"./Images/logo.png": 206,
	"./Images/logo.svg": 690,
	"./Images/placeholder.png": 652,
	"./Images/profilepic.jpg": 350,
	"./Michael_Farmer_Resume.pdf": 909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;